var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3766_11884)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 9.6C10.5431 9.6 9.2 10.9431 9.2 12.6C9.2 14.2569 10.5431 15.6 12.2 15.6C13.8569 15.6 15.2 14.2569 15.2 12.6C15.2 10.9431 13.8569 9.6 12.2 9.6ZM10.4 12.6C10.4 11.6059 11.2059 10.8 12.2 10.8C13.1941 10.8 14 11.6059 14 12.6C14 13.5941 13.1941 14.4 12.2 14.4C11.2059 14.4 10.4 13.5941 10.4 12.6Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 6C10.1994 6 10.012 6.10026 9.90077 6.26718L8.87889 7.8H6.8C6.32261 7.8 5.86477 7.98964 5.52721 8.32721C5.18964 8.66477 5 9.12261 5 9.6V16.2C5 16.6774 5.18964 17.1352 5.52721 17.4728C5.86477 17.8104 6.32261 18 6.8 18H17.6C18.0774 18 18.5352 17.8104 18.8728 17.4728C19.2104 17.1352 19.4 16.6774 19.4 16.2V9.6C19.4 9.12261 19.2104 8.66477 18.8728 8.32721C18.5352 7.98964 18.0774 7.8 17.6 7.8H15.5211L14.4992 6.26718C14.3879 6.10026 14.2006 6 14 6H10.4ZM9.69923 8.73282L10.7211 7.2H13.6789L14.7008 8.73282C14.812 8.89974 14.9994 9 15.2 9H17.6C17.7591 9 17.9117 9.06321 18.0243 9.17574C18.1368 9.28826 18.2 9.44087 18.2 9.6V16.2C18.2 16.3591 18.1368 16.5117 18.0243 16.6243C17.9117 16.7368 17.7591 16.8 17.6 16.8H6.8C6.64087 16.8 6.48826 16.7368 6.37574 16.6243C6.26321 16.5117 6.2 16.3591 6.2 16.2V9.6C6.2 9.44087 6.26321 9.28826 6.37574 9.17574C6.48826 9.06321 6.64087 9 6.8 9H9.2C9.40061 9 9.58795 8.89974 9.69923 8.73282Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3766_11884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.69c7107e8c9d9bf19a4257e082bfda46.svg";
export { ForwardRef as ReactComponent };